// routes
import { PATH_DASHBOARD } from "src/routes/paths";

const menuConfig = [
  {
    title: "Home",
    icon: "",
    path: PATH_DASHBOARD.home,
  },
  {
    title: "My List",
    icon: "",
    path: PATH_DASHBOARD.mylist,
  },
  {
    title: "Movies",
    icon: "",
    path: PATH_DASHBOARD.movies,
  },
  {
    title: "TV shows",
    icon: "",
    path: PATH_DASHBOARD.tvshows,
  },
  // {
  //   title: "Replay TV",
  //   icon: "",
  //   path: PATH_DASHBOARD.replaytv,
  // },
  {
    title: "Producers",
    icon: "",
    path: PATH_DASHBOARD.producers,
  },
];

export default menuConfig;
